var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, cloneElement, isValidElement, useState } from 'react';
import { FieldFooter } from './Footer';
import { FieldHeader } from './Header';
import { Accessories, Control, Input } from './styles';
import { AssistiveText } from '../AssistiveText';
import { Label } from '../Label';
export var Field = function (_a) {
  var children = _a.children,
    after = _a.after,
    assistiveText = _a.assistiveText,
    before = _a.before,
    disabled = _a.disabled,
    error = _a.error,
    label = _a.label,
    toolExtension = _a.toolExtension,
    _b = _a.withoutFooter,
    withoutFooter = _b === void 0 ? false : _b,
    _c = _a.withoutHeader,
    withoutHeader = _c === void 0 ? false : _c,
    resetOfProps = __rest(_a, ["children", "after", "assistiveText", "before", "disabled", "error", "label", "toolExtension", "withoutFooter", "withoutHeader"]);
  var _d = useState(false),
    hasFocus = _d[0],
    setHasFocus = _d[1];
  var focusChange = function (hasFocus) {
    setHasFocus(hasFocus);
  };
  var child = Children.toArray(children)[0];
  var fieldName = typeof child === 'object' && child && 'props' in child && child.props.name || '';
  return _jsxs(Control, __assign({}, resetOfProps, {
    children: [!withoutHeader && _jsxs(FieldHeader, {
      children: [isValidElement(label) ? cloneElement(label, {
        htmlFor: fieldName,
        disabled: disabled
      }) : _jsx(Label, {
        disabled: disabled,
        htmlFor: fieldName,
        children: label
      }), toolExtension && isValidElement(toolExtension) ? cloneElement(toolExtension, __assign({
        children: children,
        label: label,
        assistiveText: assistiveText,
        before: before,
        after: after,
        error: error
      }, resetOfProps)) : null]
    }), isValidElement(before) ? cloneElement(before, {
      error: error
    }) : before ? _jsx(Accessories, {
      error: Boolean(error),
      children: before
    }) : null, _jsx(Input, {
      children: cloneElement(children, {
        error: error,
        focus: Boolean(hasFocus),
        focusChange: focusChange
      })
    }), isValidElement(after) ? cloneElement(after, {
      error: error
    }) : after ? _jsx(Accessories, {
      error: Boolean(error),
      children: after
    }) : null, !withoutFooter && _jsx(FieldFooter, {
      children: isValidElement(error) ? cloneElement(error) : isValidElement(assistiveText) ? cloneElement(assistiveText, {
        error: error
      }) : assistiveText || error ? _jsx(AssistiveText, {
        error: Boolean(error),
        children: error || assistiveText
      }) : _jsx(AssistiveText, {
        children: "\u00A0"
      })
    })]
  }));
};